export default __webpack_public_path__ + "static/media/redux.ee9da186.png";